var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg37(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 648,
    height: 209,
    viewBox: "0 0 648 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M556.652 0.423828L466.109 52.4242V156.439L556.652 208.44L647.181 156.439V52.4242L556.652 0.423828Z",
    fill: "#ACA4E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M333.922 0.423828L252.186 39.6127L232.007 127.624L288.592 198.167L379.266 198.182L435.838 127.624L415.659 39.6127L333.922 0.423828Z",
    fill: "#776BCE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.427 0.423828L20.6907 39.6127L0.511734 127.624L57.0829 198.167L147.757 198.182L204.343 127.624L184.164 39.6127L102.427 0.423828Z",
    fill: "#776BCE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg37);
export default __webpack_public_path__ + "static/media/37.f173766647c45e77363766d5496cdcd3.svg";
export { ForwardRef as ReactComponent };